/* eslint-disable react/forbid-prop-types,import/no-unresolved */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { MAIN_ICON_COLORS } from 'assets/components';
import { LEDGER_ENTRY_SOURCE_FUND } from '../constants';
import Icon from '../../../components/Icon';
import { ICONS } from '../../../components/Icon/constants';

const TransactionsFilters = ({
  setFilterBy,
  showSearchInput = false,
  renderSearchInput = () => {},
  toggleSearchInput = () => {},
  openCalendar = () => {},
  filterBy,
  calendarSearch = {},
}) => {
  const { t: translate } = useTranslation();
  const [openFilters, setOpenFilters] = useState(false);
  const openFilter = () => {
    setOpenFilters(!openFilters);
  };

  const renderFilters = () => (
    <div
      className="card-transaction-filters"
      tabIndex={-1}
      role="button"
      onKeyDown={null}
      onMouseEnter={openFilter}
      onMouseLeave={openFilter}
      onClick={openFilter}>
      <div style={{ width: '1.5rem', height: '1.5rem' }}>
        <Icon
          icon={
            openFilters || filterBy !== LEDGER_ENTRY_SOURCE_FUND.ALL
              ? ICONS.FILLED_FILTER
              : ICONS.FITLER
          }
          color={
            openFilters || filterBy !== LEDGER_ENTRY_SOURCE_FUND.ALL
              ? MAIN_ICON_COLORS.PRIMARY
              : MAIN_ICON_COLORS.WHITE
          }
        />
      </div>

      {openFilters && (
        <div className="card-transaction-filters-open">
          <div className="py-3 px-4 bg-lighter rounded-3">
            <span className="text-shadow text-f5">{translate('filter_by')}</span>
            <ul style={{ listStyle: 'none' }} className="p-0">
              <li className="py-3">
                <span
                  role="button"
                  tabIndex={0}
                  onKeyDown={null}
                  className="text-white text-hover-dimmed"
                  onClick={() => {
                    setFilterBy(LEDGER_ENTRY_SOURCE_FUND.ALL);
                    openFilter();
                  }}>
                  {translate('all_transactions')}
                </span>
              </li>
              <li className="py-2">
                <span
                  role="button"
                  tabIndex={0}
                  onKeyDown={null}
                  className={`text-hover-dimmed ${
                    filterBy === LEDGER_ENTRY_SOURCE_FUND.CRYPTO ? 'text-primary' : 'text-white'
                  }`}
                  onClick={() => {
                    setFilterBy(LEDGER_ENTRY_SOURCE_FUND.CRYPTO);
                    openFilter();
                  }}>
                  {translate('by_outgoings')}
                </span>
              </li>
              <li className="py-3">
                <span
                  role="button"
                  tabIndex={0}
                  onKeyDown={null}
                  className={`text-hover-dimmed ${
                    filterBy === LEDGER_ENTRY_SOURCE_FUND.PAID_IN ? 'text-primary' : 'text-white'
                  }`}
                  onClick={() => {
                    setFilterBy(LEDGER_ENTRY_SOURCE_FUND.PAID_IN);
                    openFilter();
                  }}>
                  {translate('by_income')}
                </span>
              </li>
              <li className="py-3">
                <span
                  role="button"
                  tabIndex={0}
                  onKeyDown={null}
                  className={`text-hover-dimmed ${
                    filterBy === LEDGER_ENTRY_SOURCE_FUND.CRYPTODRAFT
                      ? 'text-primary'
                      : 'text-white'
                  }`}
                  onClick={() => {
                    setFilterBy(LEDGER_ENTRY_SOURCE_FUND.CRYPTODRAFT);
                    openFilter();
                  }}>
                  {translate('by_cryptodraft')}
                </span>
              </li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );

  return (
    <>
      <div
        className="d-block d-md-none position-sticky top-0 bg-lighter w-100 start-0 px-3 mb-2"
        style={{ zIndex: 2 }}>
        <div className="d-flex flex-row align-items-center justify-content-between mx-0">
          {!showSearchInput && (
            <i
              aria-label="search"
              role="button"
              style={{ zIndex: 999 }}
              tabIndex={-1}
              onKeyDown={toggleSearchInput}
              className="d-flex bg-lighter icon-search-other text-dark text-f4 border rounded-3 border-disabled p-1"
              onClick={toggleSearchInput}
            />
          )}
          {showSearchInput && renderSearchInput()}
          <div className="d-flex gap-3">
            {renderFilters()}
            <i
              aria-label="calendar"
              role="button"
              tabIndex={-1}
              onKeyDown={() => {}}
              className={`d-flex bg-lighter icon-calendar-navigation ${
                calendarSearch?.fromDate || calendarSearch?.toDate ? 'text-primary' : 'text-dark'
              } text-f4 border rounded-3 p-1 border-disabled`}
              onClick={openCalendar}
            />
          </div>
        </div>
      </div>
      <div className="d-none d-md-block">{renderFilters()}</div>
    </>
  );
};

export default TransactionsFilters;
TransactionsFilters.propTypes = {
  setFilterBy: PropTypes.func.isRequired,
  showSearchInput: PropTypes.bool,
  toggleSearchInput: PropTypes.func,
  renderSearchInput: PropTypes.func,
  openCalendar: PropTypes.func,
  filterBy: PropTypes.string.isRequired,
  calendarSearch: PropTypes.object,
};
